import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Checkbox } from '@mui/material';

const BpIcon = styled('span')(() => ({
	// border: '1px solid #09A8B0', //
	border: '1px solid var(--np-primary-color)', //
	borderRadius: '0.25em', //
	width: '16px',
	height: '16px',
	backgroundColor: '#f5f8fa',
	backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
	'.Mui-focusVisible &': {
		outline: '2px auto rgba(19,124,189,.6)',
		outlineOffset: 2,
	},
	'input:hover ~ &': {
		backgroundColor: '#ebf1f5',
	},
	'input:disabled ~ &': {
		borderColor: '#99c5c8', //
		boxShadow: 'none',
		background: 'rgba(206,217,224,.5)',
	},
}));

const BpCheckedIcon = styled(BpIcon)({
	// backgroundColor: '#09A8B0', //
	backgroundColor: 'var(--np-primary-color)',
	backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
	'&:before': {
		display: 'block',
		//width: '16px',
		height: '16px',
		backgroundImage:
			"url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
			" fill-rule='red' clip-rule='red' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
			"1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
		content: '""',
	},
	'input:hover ~ &': {
		backgroundColor: 'var(--np-primary-color)', //
	},
});

const BpCheckbox = (props) => {
	return (
		<Checkbox
			sx={{
				'&:hover': { bgcolor: 'transparent' },
			}}
			disableRipple
			color="default"
			checkedIcon={<BpCheckedIcon />}
			icon={<BpIcon />}
			inputProps={{ 'aria-label': 'Checkbox demo' }}
			{...props}
		/>
	);
};

export default function CustomizedCheckbox(props) {
	return (
		<>
			<BpCheckbox {...props} />
		</>
	);
}
